import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../parseError';
import { Toast } from '../../../../../../Notification';

const updateTourActivityFlag = async ({ state, userId, editTourActivityFlag, updateState, refreshPage }) => {
  const { resource, itemDetails } = state;
  const { tourActivityFlagId, tourId, activityFlagId, jobElementId, tourActivityFlagStartTime, tourActivityFlagEndTime } = itemDetails;
  console.log(tourActivityFlagStartTime.format('YYYY-MM-DD HH:mm:SS')); // debug
  console.log(tourActivityFlagEndTime.format('YYYY-MM-DD HH:mm:SS'));
  let parameters = {
    tourActivityFlagId,
    tourId,
    activityFlagId,
    jobElementId: jobElementId || 0,
    startTime: tourActivityFlagStartTime.format('YYYY-MM-DD HH:mm:SS'),
    endTime: tourActivityFlagEndTime.format('YYYY-MM-DD HH:mm:SS'),
    updatingUserId: userId
  };
  const day = moment(tourActivityFlagStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Activity Flag Updated', description: `For ${resource.name} on ${day}`};
  try {
    await editTourActivityFlag(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'editTourActivityFlag',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Updating Activity Flag Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default updateTourActivityFlag;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/tour/activityFlag/updateTourActivityFlag.js